module.exports = __webpack_public_path__ + "img/trash.a34c75b4.svg";